// location saga
import { all, call, put, takeEvery } from "redux-saga/effects";
import * as actions from "../slices/doctorsSlice";

import doctorApis from "src/api/doctor";
import { common } from "src/types/index";
import { constants } from "src/constants/common";
import { doctors } from "src/types/index";

// get hospitals list saga
const GetHospitalsListSaga = function* GetHospitalsListSaga({
  payload: { resolve, reject, payload },
}: {
  payload: any;
}) {
  try {
    const response: common.ResponseGenerator = yield call(
      doctorApis.getHospitalsInCityList,
      payload
    );

    if (Number(response?.code) === -1) {
      throw new Error("Session Expire");
    } else if (Number(response?.code) === 0) {
      throw new Error(response?.message);
    } else if (!response) {
      throw new Error(constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG);
    }
    yield put(actions.getHospitalsListSuccess(response?.data || []));
    resolve(response);
  } catch (error) {
    yield put(
      actions.getHospitalsListError(
        error instanceof Error
          ? error?.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
    reject(error);
  }
};

// get doctors list saga
const GetDoctorsListSaga = function* GetDoctorsListSaga({
  payload: { resolve, reject, payload },
}: {
  payload: any;
}) {
  try {
    const response: common.ResponseGenerator = yield call(
      doctorApis.getDoctorsList,
      payload
    );

    if (Number(response?.code) === -1) {
      throw new Error("Session Expire");
    } else if (Number(response?.code) === 0) {
      throw new Error(response?.message);
    } else if (!response) {
      throw new Error(constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG);
    }
    // Support both { data: [...] } and { data: { data: [...] } } response structures
    const doctorsData = Array.isArray(response?.data)
      ? response.data
      : response?.data?.data || [];
    yield put(actions.getDoctorsListSuccess(doctorsData));
    resolve(response);
  } catch (error) {
    yield put(
      actions.getDoctorsListError(
        error instanceof Error
          ? error?.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
    reject(error);
  }
};

// add doctor saga
const AddDoctorSaga = function* AddDoctorSaga({
  payload: { resolve, reject, payload },
}: {
  payload: {
    resolve: (response: any) => void;
    reject: (error: any) => void;
    payload: doctors.AddDoctorPayload;
  };
}) {
  try {
    const response: common.ResponseGenerator = yield call(
      doctorApis.addDoctor,
      payload
    );

    if (Number(response?.code) === -1) {
      throw new Error("Session Expire");
    } else if (Number(response?.code) === 0) {
      throw new Error(response?.message);
    } else if (!response) {
      throw new Error(constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG);
    }
    yield put(actions.addDoctorSuccess(response?.data || []));
    resolve(response);
  } catch (error) {
    yield put(
      actions.addDoctorError(
        error instanceof Error
          ? error?.message
          : constants.ERROR_MESSAGES.SOMETHING_WENT_WRONG
      )
    );
    reject(error);
  }
};

export default function* doctorsSaga() {
  yield all([
    takeEvery(actions.getHospitalsListRequest, GetHospitalsListSaga),
    takeEvery(actions.getDoctorsListRequest, GetDoctorsListSaga),
    takeEvery(actions.addDoctorRequest, AddDoctorSaga),
  ]);
}
